<template>
  <div class="timer-loader" v-if="showTimer">
    <timer
      :initTimer="initTimer"
      :timerDelayInSec="timerDelayInSec"
      :hasTimerStart="showTimer"
      :timerWidth=116
      :timerHeight=116
      :hasSetTimerAPI=false
      @getTimer="getTimer"
    />
    <p :key="timerVal">{{ timerVal && timerVal <= 1 ? 'Koma svo!' : 'Þú átt teig eftir..' }}</p>
  </div>
</template>

<script>
export default {
  name: 'TimerLoader',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initTimer: {
      type: Number,
      default: 2,
    },
    timerDelayInSec: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      timerVal: this.initTimer,
      showTimer: false,
    }
  },
  watch: {
    show: {
      handler(newVal) {
        this.showTimer = newVal
      },
    },
    timerVal: {
      handler(val) {
        if (val === 0) {
          this.showTimer = false
          this.$emit('proceed', true)
        }
      },
      immediate: true
    },
  },
  methods: {
    getTimer(val) {
      this.timerVal = val
    },
  },
}
</script>

<style lang="scss">
.timer-loader .sec-label {
  display: none;
}
</style>
<style lang="scss" scoped>
.timer-loader {
  background: rgba(255, 255, 255, 1);
  position: absolute;
  left: 0;
  right: 0;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1;
  height: 100%;
  animation-name: fadingOffEffect;
  .timer-wrapper {
    margin-bottom: 34px;
  }
  p {
    color: #011627;
    font-weight: 400;
    font-size: 22px;
    line-height: 26px;
  }
}
</style>